export function generateUUID() {
    // Prefer native implementation when available
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID();
    }
  
    // Fallback: use crypto.getRandomValues if available, otherwise Math.random
    const getRandomBytes = () => {
      if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
        const bytes = new Uint8Array(16);
        crypto.getRandomValues(bytes);
        return bytes;
      }
      // Low-entropy fallback
      const bytes = new Uint8Array(16);
      for (let i = 0; i < 16; i++) bytes[i] = Math.floor(Math.random() * 256);
      return bytes;
    };
  
    const bytes = getRandomBytes();
  
    // Per RFC4122: set version bits (4) and variant bits (10)
    bytes[6] = (bytes[6] & 0x0f) | 0x40; // version 4
    bytes[8] = (bytes[8] & 0x3f) | 0x80; // variant 10
  
    const toHex = (b) => b.toString(16).padStart(2, '0');
    const hex = Array.from(bytes, toHex).join('');
  
    // Insert hyphens: 8-4-4-4-12
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
  }